import styled from "styled-components";
import { mainColor } from "../../../styles/global";

export const StoryCardWrapper = styled.div`
  background: #fdf2f4;
  min-height: 320px;
  padding: 40px;
  border-radius: 13px;
  margin-top: 1rem;
  min-height: 100%;
  min-width: 420px;
  &:hover{
    // transform: scale(1.05);
    // transition: ease-in-out all .5s;
  }
  div {
    h1 {
      margin-bottom: 30px;
      color: ${mainColor};
      @media screen and (max-width: 768px) {
        font-size: 16px;
        font-family: "Avenir";
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0.01em;
      }
    }
  }
  @media screen and (max-width: 768px) {
    min-width: 300px;
    min-height: 200px;
    padding: 30px 30px;
  }
`;
